// extracted by mini-css-extract-plugin
export default {"title":"pilih-marketing-pembeli_title__UuPJe"};